module.exports = __webpack_public_path__ + "media/images/athletes/2206-f5bbd38a175212238c4425fbaa94cc15.png";